/** Modulo Chat (230) — contracts/enums.yaml */
export const CHAT_ACAO = {
  VER: 2301,
  ENVIAR: 2302,
  CRIAR_GRUPO: 2303,
  ADMINISTRAR_GRUPO: 2304,
  SAIR_GRUPO: 2305,
  INICIAR_CONVERSA_FAMILIA: 2306,
  CRIAR_GRUPO_FAMILIA: 2307,
  INICIAR_CONVERSA_ESCOLA: 2308,
} as const;

export const CHAT_ACOES_MODULO = [
  CHAT_ACAO.VER,
  CHAT_ACAO.ENVIAR,
  CHAT_ACAO.CRIAR_GRUPO,
  CHAT_ACAO.ADMINISTRAR_GRUPO,
  CHAT_ACAO.SAIR_GRUPO,
  CHAT_ACAO.INICIAR_CONVERSA_FAMILIA,
  CHAT_ACAO.CRIAR_GRUPO_FAMILIA,
] as const;
